//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        rowguid: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            form: {
                auditStatus: 'SHTG',
                auditRemark: '',
            },
        };
    },
    methods: {
        submitHandler() {
            if (this.form.auditStatus === 'SHTH' && !this.form.auditRemark) {
                showMsgBox('请输入审核备注');

                return;
            }

            this.$post(
                '/bhtong/settle/settBill/audit',
                {
                    ...this.form,
                    billId: this.rowguid,
                },
                () => {
                    ShowMsg('审核成功', 'success');

                    this.cancelHandler();
                }
            );
        },
        cancelHandler() {
            this.$emit('close');
        },
    },
};
